import { FormattedMessage } from 'react-intl';
import _ from 'lodash';
import MenuItem from 'apollo-react/components/MenuItem';
import Paper from 'apollo-react/components/Paper';
import React from 'react';
import Select from 'apollo-react/components/Select';
import Typography from 'apollo-react/components/Typography';

import { BestDayTime, MessageFrequencyCapping } from '../../constants';

export const bdtChannels = (activityType, configurationPageFormChannel, channels) => {
  const result = _.includes(activityType, MessageFrequencyCapping)
    ? _.filter(channels, channel => channel.channelCode === configurationPageFormChannel)
    : channels;

  return result;
};

const BestDayTimePage = ({
  intl,
  classes,
  channels,
  bestDayTimeChannel,
  change,
  configurationPageFormChannel,
  metrics,
  metric,
  activityType,
  status,
}) =>
  _.includes(activityType, BestDayTime) && (
    <Paper className={classes.configurationPageWrapper} elevation={2}>
      <Typography variant="overline">
        {intl.formatMessage({ id: 'journeyBuilder.BestDayTime' })}
      </Typography>
      <Select
        name="metric"
        label={intl.formatMessage({ id: 'journeyBuilder.metrics' })}
        value={metric}
        fullWidth
        required
        canDeselect={false}
        onChange={e => {
          change('metric', e.target.value);
        }}
        disabled={status}
      >
        {metrics.map(e => (
          <MenuItem key={e.name} value={e.name}>
            {intl.formatMessage({ id: `journeyBuilder.${e.name}` })}
          </MenuItem>
        ))}
      </Select>
      <Select
        name="bestDayTimeChannel"
        label={intl.formatMessage({ id: 'journeyBuilder.BDTChannel' })}
        // eslint-disable-next-line iqvia/ternaries/no-empty-ternary
        value={bestDayTimeChannel}
        fullWidth
        canDeselect
        onChange={e => {
          change('bestDayTimeChannel', e.target.value);
        }}
        disabled={status}
      >
        {bdtChannels(activityType, configurationPageFormChannel, channels).map(e => (
          <MenuItem key={e.channelDisplayName} value={e.channelCode}>
            {e.channelDisplayName}
          </MenuItem>
        ))}
      </Select>
      {_.includes(activityType, MessageFrequencyCapping) &&
        _.includes(activityType, BestDayTime) && (
          <Typography variant="body2">
            <FormattedMessage id="journeyBuilder.channelNotification" />
          </Typography>
        )}
    </Paper>
  );

BestDayTimePage.displayName = 'BestDayTimePage';
export default BestDayTimePage;



// WEBPACK FOOTER //
// ./src/JourneyBuilder/SendOptimizer/components/BestDayTime/BestDayTimePage.js